import { Toaster } from 'react-hot-toast'
import Header from '@/components/Header'
import Hero from '@/components/Hero'
import Calculator from '@/components/Calculator'
import Services from '@/components/Services'
import Faq from '@/components/Faq'
import Footer from '@/components/Footer'

function Home() {
  return (
    <div id="top" className="min-h-screen bg-[#F1F5F9] font-sans">
      <Toaster
        position="top-right"
        toastOptions={{
          style: { background: '#0F172A', color: '#fff', fontSize: '14px' },
          success: { iconTheme: { primary: '#10B981', secondary: '#fff' } },
        }}
      />
      <Header />
      <main>
        <Hero />
        <Calculator />
        <Services />
        <Faq />
      </main>
      <Footer />
    </div>
  )
}

export default Home
